import { ReactImageGalleryItem } from "react-image-gallery";

type ImageGalleryItemComponentProps = {
    item: ReactImageGalleryItem;
};

export const ImageGalleryItemComponent = (props: ImageGalleryItemComponentProps) => {
    const { item } = props;

    return (
        <div>
            <img
                src={item.original}
                alt={item.originalAlt}
                srcSet={item.srcSet}
                sizes={item.sizes}
                className={item.originalClass}
            />
            {item.description && (
                <span>
                    {item.description}
                    {item.original && item.originalTitle && (
                        <a href={item.original}>
                            {item.originalTitle}
                        </a>
                    )}
                </span>
            )}
        </div>
    );
};